import { useTranslation } from "react-i18next";

import type { PartyPlayFormat } from "../types/api";

export function PartyPlayFormatChips({ format }: { format: PartyPlayFormat }) {
  const { t } = useTranslation();
  const tags =
    format === "both"
      ? [
          { key: "teams", label: t("party.playFormatTags.teams") },
          { key: "solo", label: t("party.playFormatTags.solo") },
        ]
      : format === "teams"
        ? [{ key: "teams", label: t("party.playFormatTags.teams") }]
        : [{ key: "solo", label: t("party.playFormatTags.solo") }];

  return (
    <>
      {tags.map((x, idx) => (
        <span key={`${x.key}-${idx}`} className="party-chip" style={{ fontSize: 10, fontWeight: 700 }}>
          {x.label}
        </span>
      ))}
    </>
  );
}
